<script>
import uniqueId from 'lodash/uniqueId'

export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: 'Invalid input.'
    },
    invalid: {
      default: false
    }
  },

  data () {
    return {
      id: uniqueId('input-')
    }
  },

  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    }
  },

  computed: {
    labelBindings () {
      return {
        for: this.id,
        value: this.value,
        'class': 'form-label'
      }
    },

    inputBindings() {
      return {
        id: this.id,
        value: this.value,
        'class': 'form-control mb-2'
      }
    },

    inputEvents () {
      return {
        input: this.onInput
      }
    }
  }
}
</script>
